import { render, staticRenderFns } from "./OrdersGrid.vue?vue&type=template&id=96c2031a&scoped=true"
import script from "./OrdersGrid.vue?vue&type=script&lang=js"
export * from "./OrdersGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c2031a",
  null
  
)

export default component.exports